<template>
	<PageContainer size="s">
		<AmeliproCard
			card-title="Réinitialisez votre mot de passe"
			class="pa-6"
		>
			<VForm ref="form">
				<AmeliproTextField
					id="passworduser"
					v-model="passworduser"
					:rules="passwordRules"
					required
					aria-required
					label="Mot de passe"
					placeholder="Mot de passe"
					class="text-no-wrap"
					:type="typeChamp"
					validate-on-blur
					@keyup.enter="submitResetPassword"
				>
					<template #append>
						<AmeliproIconBtn
							id="displayPassword"
							btn-label="displayPassword"
							icon-bg-color="ap-white"
							icon-color="ap-blue darken-1"
							icon-hover-bg-color="ap-blue darken-2"
							icon-hover-color="ap-white"
							icon="oeil"
							large
							@click="togglePasswordVisibility"
						/>
					</template>
				</AmeliproTextField>

				<AmeliproTextField
					id="passworduserDeux"
					v-model="passworduserDeux"
					:rules="passwordRulesFull"
					required
					aria-required
					label="Confirmation du mot de passe"
					placeholder="Mot de passe"
					class="text-no-wrap"
					:type="typeChamp"
					validate-on-blur
					@keyup.enter="submitResetPassword"
				>
					<template #append>
						<AmeliproIconBtn
							id="displayPassword"
							btn-label="displayPassword"
							icon-bg-color="ap-white"
							icon-color="ap-blue darken-1"
							icon-hover-bg-color="ap-blue darken-2"
							icon-hover-color="ap-white"
							icon="oeil"
							large
							@click="togglePasswordVisibility"
						/>
					</template>
				</AmeliproTextField>

				<AmeliproBtn @click="submitResetPassword">
					Valider
				</AmeliproBtn>
			</VForm>
		</AmeliproCard>
	</PageContainer>
</template>

<script lang="ts">
	import Component, { mixins } from 'vue-class-component';

	import { required } from '@cnamts/vue-dot/src/rules/required';
	import { Refs, VForm } from '@cnamts/vue-dot/src/types';
	import { resetPasswordApi } from '@/services/api/api';
	import { store } from '@/store';
	import UserMixin from '@/mixins/userMixin';
	const MixinsDeclaration = mixins(UserMixin);

	@Component<ResetPassword>({
		mounted() {
			// Accédez au paramètre de l'URL
			this.token = this.$route.params.token;
		}
	})
	export default class ResetPassword extends MixinsDeclaration {
		$refs!: Refs<{
			form: VForm;
		}>;

		token = '';
		passworduser = '';
		passworduserDeux = '';

		passwordRules = [required, this.validatePassword];
		passwordRulesFull = [required, this.validatePassword, this.passwordMatch];

		showPassword = false;
		typeChamp = 'password';
		// Todo : mixins
		togglePasswordVisibility(): void {
			this.showPassword = !this.showPassword;
			this.typeChamp = this.showPassword ? 'text' : 'password';
		}

		passwordMatch(): boolean | string {
			return this.stringMatch(
				this.passworduser,
				this.passworduserDeux,
				'Les mots de passe ne correspondent pas'
			);
		}

		async submitResetPassword(): Promise<void> {
			await this.$nextTick(); // attend la mise à jour du cycle de vie (dom)
			if (this.$refs.form.validate()) {
				try {
					if (this.passworduser) {
						// ! : opérateru de non nullité
						const response = await resetPasswordApi({
							token: this.token,
							password: this.passworduser
						});

						if (response && response.status === 200) {
							// Redirige vers la page de connexion
							this.$router.push({ name: 'login' });
							// Affiche message à l'utilisateur
							store.dispatch('notification/add', {
								type: 'success',
								message: response.data.message
							});
						}
					}
				} catch (error: any) {
					store.dispatch('notification/add', {
						type: 'error',
						message:
							'Le lien de réinitialisation de mot de passe n\'est plus valide. Veuillez réitérer votre demande.'
					});
				}
			}
		}

		// new
	}
</script>
